import { requests } from './baseServices'

export const CountryCurrencyServices = {    
    getAll: (criteria) => requests.get('api/countrycurrencies', criteria),
    getAllWithOptions: (criteria) => requests.post('api/countrycurrencies/filtered', criteria),
    getById: (id) => requests.get(`api/countrycurrencies/${id}`),
    update: (id, template) => requests.put(`api/countrycurrencies/${id}`, template),
    create: (template) => requests.post(`api/countrycurrencies`, template),    
    delete: (id) => requests.delete(`api/countrycurrencies/${id}`),        
};